import * as types from '../actiontypes';
import {promiseAreas, serviceURL, userType, ValidationGroup} from './../../util/uiconstants';
import Env from '../../util/env';

export function getUIFilters(url) {
	return {
		type: types.GET_SAVED_FILTERS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.GET_SAVED_FILTERS
			}
		}
	};
}

export function saveFilters(url, filters) {
	return {
		type: types.SAVE_FILTERS,
		meta: {
			api: {
				url,
				method: 'POST',
				data: filters
			}
		}
	}; //TODO: replace with types.*
	//return {type: types._ACTION, payload};
}

export function updateFilters(url,filter) {
	return {
		type: types.UPDATE_FILTERS,
		meta: {
			api: {
				url,
				method: 'PUT',
				data:filter
			}
		}
	}; //TODO: replace with types.*
	//return {type: types._ACTION, payload};
}

export function deleteFilters(url, filterId) {
const deleteFilter = {
		type: types.DELETE_FILTERS,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		}
	};
	deleteFilter.filterId = filterId;
	return deleteFilter;
}

